import type { TokenUsage } from './types';
import type {
    AIDisclosureParagraphEditType,
    AIDisclosureParagraphType,
    StreamStatus,
} from '@/domains/disclosure/enums';
import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';

export interface ApiGetDisclosureContentRequest<ContentType> {
    task_id: string;
    current_step: string;
    content_type: ContentType;
    text?: string;
}

export type ApiGetDisclosureContentResponse = {
    content: string;
    token_usage: TokenUsage;
    status: StreamStatus;
};

export const GetDisclosureContent = Symbol('GetDisclosureContent');

export interface GetDisclosureContent {
    getDisclosureContent(data: ApiGetDisclosureContentRequest<AIDisclosureParagraphEditType | AIDisclosureParagraphType>): PsHttpSSE<ApiGetDisclosureContentResponse>;
}
